function serializeRequestData(obj, prefix) {
    var str = [],
        p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];
            // Skip null and undefined values
            if (v === null || v === undefined) {
                continue;
            }
            // Handle arrays and objects
            if (v !== null && typeof v === "object") {
                if (Array.isArray(v)) {
                    // Handle arrays
                    v.forEach((item, index) => {
                        if (item !== null && item !== undefined) {
                            if (typeof item === "object") {
                                str.push(serializeRequestData(item, k + "[" + index + "]"));
                            } else {
                                str.push(encodeURIComponent(k + "[" + index + "]") + "=" + encodeURIComponent(item));
                            }
                        }
                    });
                } else {
                    str.push(serializeRequestData(v, k));
                }
            } else {
                str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
    }
    return str.join("&");
}


export async function sendRequest(path, method = 'GET', data, withToken = false){
    try {

        let initData = {
            method: method,
            headers: {'Content-Type': 'application/json'},
            // credentials: true
        };



        if(method === 'POST' || method === 'PUT'){
            initData.body = JSON.stringify(data);
        } else if(method === 'GET' || method === 'DELETE') {
            // Only serialize if data exists and is not empty
            if(data && typeof data === 'object' && Object.keys(data).length > 0) {
                const serialized = serializeRequestData(data);
                if(serialized) {
                    path+= '?' + serialized;
                }
            }
        }

        if(withToken){
            const token = localStorage.getItem('access_token');
            if (!token) {
                console.error('No access token found');
                throw new Error('No access token');
            }
            initData.headers['Authorization'] = 'Bearer ' + token;
        }

        const response = await fetch('/api/v1/'+path, initData);
        if(response.status === 200) {
            return await response.json();
        }
        if(response.status === 201) {
            return await response.json();
        }
        if(response.status === 422){
            try {
                const errorData = await response.json();
                return {errors: errorData}
            } catch (e) {
                return {errors: {message: 'Validation error'}}
            }
        }
        if(response.status === 401){
            // Unauthorized - clear token and redirect to login
            localStorage.removeItem('access_token');
            window.location.href = '/login';
            throw new Error('Unauthorized');
        }
        // For other status codes, try to get error message
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Request failed with status ${response.status}`);
    } catch (error){
        console.error('sendRequest error:', error);
        throw error;
    }
}